import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptTranslation from './common/locales/pt/translation.json';
import enTranslation from './common/locales/en/translation.json';
import esTranslation from './common/locales/es/translation.json';
import deTranslation from './common/locales/de/translation.json';
import frTranslation from './common/locales/fr/translation.json';
import itTranslation from './common/locales/it/translation.json';
import nlTranslation from './common/locales/nl/translation.json';
import plTranslation from './common/locales/pl/translation.json';

const resources = {
    pt: { translation: ptTranslation },
    en: { translation: enTranslation },
    es: { translation: esTranslation },
    de: { translation: deTranslation },
    fr: { translation: frTranslation },
    it: { translation: itTranslation },
    nl: { translation: nlTranslation },
    pl: { translation: plTranslation },
};

i18n
    .use(initReactI18next)
    .init({
        compatibilityJSON: 'v4',
        resources,
        lng: 'pt',
        fallbackLng: 'pt',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        backend: {
            loadPath: '/common/locales/{{lng}}/translation.json',
        },
        saveMissing: true,
    });

export default i18n;
